import {
  createContext,
  Dispatch,
  PropsWithChildren,
  useCallback,
  useEffect,
  useState
} from 'react'
import { match } from 'ts-pattern'
import { medusaClient } from 'live/liveIsomorphicInstances'
import { KEY_CART_IN_LOCALSTORAGE } from 'store/constants'

const defaultCurrency = 'EUR'

export const CurrencyContext = createContext(defaultCurrency)
export const SetCurrencyContext = createContext<Dispatch<string>>(() => {})

export const CurrencyProvider = ({ children }: PropsWithChildren) => {
  const [currency, setCurrency] = useState(defaultCurrency)
  const setCurrencyCallback: Dispatch<string> = useCallback(
    (v) => {
      localStorage.setItem('preferredCurrency', v)
      const cartId = localStorage.getItem(KEY_CART_IN_LOCALSTORAGE)
      if (cartId) {
        Promise.all([
          medusaClient.regions.list(),
          medusaClient.carts.retrieve(cartId)
        ]).then(([{ regions }, { cart }]) => {
          const region = regions.find(
            (region) => region.currency_code === v.toLowerCase()
          )
          if (region && region.id !== cart.region_id) {
            console.log('SETTING REGION CART TO', region)
            return medusaClient.carts.update(cartId, { region_id: region.id })
          }
        })
      }
      setCurrency(v)
    },
    [setCurrency]
  )
  useEffect(() => {
    const fromLocalStorage = localStorage.getItem('preferredCurrency')
    if (fromLocalStorage) {
      return setCurrencyCallback(fromLocalStorage)
    }
    try {
      const fromNavigatorLanguage = navigator.languages.find((value) =>
        ['CA', 'CH'].includes(value.split('-')[1] ?? '')
      )
      setCurrencyCallback(
        match(fromNavigatorLanguage?.split('-')[1])
          .with('CA', () => 'CAD')
          .with('CH', () => 'CHF')
          .otherwise(() => 'EUR')
      )
    } catch {}
  }, [setCurrencyCallback])
  return (
    <SetCurrencyContext.Provider value={setCurrencyCallback}>
      <CurrencyContext.Provider value={currency}>
        {children}
      </CurrencyContext.Provider>
    </SetCurrencyContext.Provider>
  )
}
